
import { createSelector } from "@ngrx/store";
import { cloneDeep } from "lodash";

import { jobInventoryFeature } from "./job-inventory.feature";

import { InventoryRoom } from "./job-inventory.state";

export const selectInventoryTotals = createSelector(
  jobInventoryFeature.selectInventoryEditor,
  (inventoryEditor) => calculateInventoryTotals(inventoryEditor.rooms),
)

function calculateInventoryTotals(rooms: InventoryRoom[]) {

  rooms = cloneDeep(rooms);

  let totalItems = 0;

  let totalVolume = 0;

  let totalWeight = 0;

  for (const room of rooms) {

    let roomItems = 0;
    let roomWeight = 0;
    let roomVolume = 0;

    for (const item of room.inventory) {
      item.totalWeight = item.weight * item.quantity;
      item.totalVolume = item.volume * item.quantity;

      roomItems += item.quantity;
      roomWeight += item.totalWeight;
      roomVolume += item.totalVolume;
    }

    room.totalItems = roomItems;
    room.totalWeight = roomWeight;
    room.totalVolume = roomVolume;

    totalItems += roomItems;
    totalWeight += roomWeight;
    totalVolume += roomVolume;
  }

  return {
    rooms,
    totalItems,
    totalVolume,
    totalWeight,
  }
}
